import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';
import bildUnbekannt from '@/assets/icons/unbekannt.svg';

export const wishPowerStorageAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '20548', image: bildJa },
    { name: 'Nein', available: true, value: 'nein', api: '20549',  image: bildNein },
    { name: 'Weiß nicht', available: true, value: 'unknown', api: '22458',  image: bildUnbekannt },
];

export const wishPowerStorageApi = {parameter: '17680', type: 'value_choice'};